export default "__VITE_ASSET__fd00d8d0__"